import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CandidateMeetingModel, InterviewDashboardResult } from "../../../interviews.models";
import { InterviewType } from "../../../interviews.enums";

@Component({
    selector: 'interview-dashboard-card-confirmed',
    templateUrl: './interview-dashboard-card-confirmed.component.html',
    standalone: false
})
export class InterviewDashboardCardConfirmedComponent {
  @Input() meeting?: CandidateMeetingModel;
  @Input() dashboardInfo: InterviewDashboardResult | null = null;

  @Output() onClickViewDetails = new EventEmitter<CandidateMeetingModel>()


  public InterviewType = InterviewType;

  clickViewDetails(meeting: CandidateMeetingModel) {
    this.onClickViewDetails.emit(meeting);
  }

  isJoinButtonEnabled(meeting: CandidateMeetingModel): boolean {
    const datesAreOnSameDay = (first: Date, second: Date) =>
      first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();

    let startDate = new Date(meeting.startDate!.utc.isO8601);
    let endDate = new Date(meeting.endDate!.utc.isO8601);
    let now = new Date();

    return datesAreOnSameDay(startDate, now) || datesAreOnSameDay(endDate, now);
  }
}
